import React from "react";

const noop = () => {};

const context = React.createContext({
	isOpen: false,
	onToggle: noop,
	onOpen: noop,
	onClose: noop,
});

export const useHeader = () => React.useContext(context);

export default context;
